var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 22 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11S17.075 0 11 0zm.119 16.91A5.908 5.908 0 015.209 11a5.908 5.908 0 015.91-5.91c1.596 0 2.93.588 3.952 1.54l-1.666 1.666v-.003c-.62-.592-1.407-.894-2.286-.894-1.95 0-3.534 1.647-3.534 3.597s1.584 3.6 3.534 3.6c1.769 0 2.973-1.011 3.22-2.4h-3.22V9.891h5.558c.074.395.114.81.114 1.24 0 3.378-2.26 5.779-5.672 5.779z"
  })));
}

export default SvgGoogle;